/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AcceptInviteRouteImport } from "./routes/accept-invite"
import { Route as AppRouteRouteImport } from "./routes/app/route"
import { Route as ComposeRouteImport } from "./routes/compose"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as TwoFactorRouteImport } from "./routes/two-factor"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as AppAdminRouteImport } from "./routes/app/admin"
import { Route as AppSearchRouteImport } from "./routes/app/search"
import { Route as AppSettingsRouteImport } from "./routes/app/settings"
import { Route as AppFolderFolderIdRouteImport } from "./routes/app/folder/$folderId"
import { Route as AppMMailboxIdRouteImport } from "./routes/app/m/$mailboxId"
import { Route as AppFolderFolderIdIndexRouteImport } from "./routes/app/folder/$folderId.index"
import { Route as AppMMailboxIdIndexRouteImport } from "./routes/app/m/$mailboxId.index"
import { Route as AppFolderFolderIdTThreadIdRouteImport } from "./routes/app/folder/$folderId.t.$threadId"
import { Route as AppMMailboxIdTThreadIdRouteImport } from "./routes/app/m/$mailboxId.t.$threadId"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: "/accept-invite",
  path: "/accept-invite",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const ComposeRoute = ComposeRouteImport.update({
  id: "/compose",
  path: "/compose",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: "/two-factor",
  path: "/two-factor",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFolderFolderIdRoute = AppFolderFolderIdRouteImport.update({
  id: "/folder/$folderId",
  path: "/folder/$folderId",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMMailboxIdRoute = AppMMailboxIdRouteImport.update({
  id: "/m/$mailboxId",
  path: "/m/$mailboxId",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFolderFolderIdIndexRoute = AppFolderFolderIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppFolderFolderIdRoute,
} as any)
const AppMMailboxIdIndexRoute = AppMMailboxIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMMailboxIdRoute,
} as any)
const AppFolderFolderIdTThreadIdRoute =
  AppFolderFolderIdTThreadIdRouteImport.update({
    id: "/t/$threadId",
    path: "/t/$threadId",
    getParentRoute: () => AppFolderFolderIdRoute,
  } as any)
const AppMMailboxIdTThreadIdRoute = AppMMailboxIdTThreadIdRouteImport.update({
  id: "/t/$threadId",
  path: "/t/$threadId",
  getParentRoute: () => AppMMailboxIdRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/accept-invite": typeof AcceptInviteRoute
  "/compose": typeof ComposeRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/app/admin": typeof AppAdminRoute
  "/app/search": typeof AppSearchRoute
  "/app/settings": typeof AppSettingsRoute
  "/app/": typeof AppIndexRoute
  "/app/folder/$folderId": typeof AppFolderFolderIdRouteWithChildren
  "/app/m/$mailboxId": typeof AppMMailboxIdRouteWithChildren
  "/app/folder/$folderId/": typeof AppFolderFolderIdIndexRoute
  "/app/m/$mailboxId/": typeof AppMMailboxIdIndexRoute
  "/app/folder/$folderId/t/$threadId": typeof AppFolderFolderIdTThreadIdRoute
  "/app/m/$mailboxId/t/$threadId": typeof AppMMailboxIdTThreadIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/accept-invite": typeof AcceptInviteRoute
  "/compose": typeof ComposeRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/app/admin": typeof AppAdminRoute
  "/app/search": typeof AppSearchRoute
  "/app/settings": typeof AppSettingsRoute
  "/app": typeof AppIndexRoute
  "/app/folder/$folderId": typeof AppFolderFolderIdIndexRoute
  "/app/m/$mailboxId": typeof AppMMailboxIdIndexRoute
  "/app/folder/$folderId/t/$threadId": typeof AppFolderFolderIdTThreadIdRoute
  "/app/m/$mailboxId/t/$threadId": typeof AppMMailboxIdTThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/accept-invite": typeof AcceptInviteRoute
  "/compose": typeof ComposeRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/app/admin": typeof AppAdminRoute
  "/app/search": typeof AppSearchRoute
  "/app/settings": typeof AppSettingsRoute
  "/app/": typeof AppIndexRoute
  "/app/folder/$folderId": typeof AppFolderFolderIdRouteWithChildren
  "/app/m/$mailboxId": typeof AppMMailboxIdRouteWithChildren
  "/app/folder/$folderId/": typeof AppFolderFolderIdIndexRoute
  "/app/m/$mailboxId/": typeof AppMMailboxIdIndexRoute
  "/app/folder/$folderId/t/$threadId": typeof AppFolderFolderIdTThreadIdRoute
  "/app/m/$mailboxId/t/$threadId": typeof AppMMailboxIdTThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/app"
    | "/accept-invite"
    | "/compose"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/app/admin"
    | "/app/search"
    | "/app/settings"
    | "/app/"
    | "/app/folder/$folderId"
    | "/app/m/$mailboxId"
    | "/app/folder/$folderId/"
    | "/app/m/$mailboxId/"
    | "/app/folder/$folderId/t/$threadId"
    | "/app/m/$mailboxId/t/$threadId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/accept-invite"
    | "/compose"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/app/admin"
    | "/app/search"
    | "/app/settings"
    | "/app"
    | "/app/folder/$folderId"
    | "/app/m/$mailboxId"
    | "/app/folder/$folderId/t/$threadId"
    | "/app/m/$mailboxId/t/$threadId"
  id:
    | "__root__"
    | "/"
    | "/app"
    | "/accept-invite"
    | "/compose"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/app/admin"
    | "/app/search"
    | "/app/settings"
    | "/app/"
    | "/app/folder/$folderId"
    | "/app/m/$mailboxId"
    | "/app/folder/$folderId/"
    | "/app/m/$mailboxId/"
    | "/app/folder/$folderId/t/$threadId"
    | "/app/m/$mailboxId/t/$threadId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ComposeRoute: typeof ComposeRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accept-invite": {
      id: "/accept-invite"
      path: "/accept-invite"
      fullPath: "/accept-invite"
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/compose": {
      id: "/compose"
      path: "/compose"
      fullPath: "/compose"
      preLoaderRoute: typeof ComposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/two-factor": {
      id: "/two-factor"
      path: "/two-factor"
      fullPath: "/two-factor"
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/admin": {
      id: "/app/admin"
      path: "/admin"
      fullPath: "/app/admin"
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/search": {
      id: "/app/search"
      path: "/search"
      fullPath: "/app/search"
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/settings": {
      id: "/app/settings"
      path: "/settings"
      fullPath: "/app/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/folder/$folderId": {
      id: "/app/folder/$folderId"
      path: "/folder/$folderId"
      fullPath: "/app/folder/$folderId"
      preLoaderRoute: typeof AppFolderFolderIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/m/$mailboxId": {
      id: "/app/m/$mailboxId"
      path: "/m/$mailboxId"
      fullPath: "/app/m/$mailboxId"
      preLoaderRoute: typeof AppMMailboxIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/folder/$folderId/": {
      id: "/app/folder/$folderId/"
      path: "/"
      fullPath: "/app/folder/$folderId/"
      preLoaderRoute: typeof AppFolderFolderIdIndexRouteImport
      parentRoute: typeof AppFolderFolderIdRoute
    }
    "/app/m/$mailboxId/": {
      id: "/app/m/$mailboxId/"
      path: "/"
      fullPath: "/app/m/$mailboxId/"
      preLoaderRoute: typeof AppMMailboxIdIndexRouteImport
      parentRoute: typeof AppMMailboxIdRoute
    }
    "/app/folder/$folderId/t/$threadId": {
      id: "/app/folder/$folderId/t/$threadId"
      path: "/t/$threadId"
      fullPath: "/app/folder/$folderId/t/$threadId"
      preLoaderRoute: typeof AppFolderFolderIdTThreadIdRouteImport
      parentRoute: typeof AppFolderFolderIdRoute
    }
    "/app/m/$mailboxId/t/$threadId": {
      id: "/app/m/$mailboxId/t/$threadId"
      path: "/t/$threadId"
      fullPath: "/app/m/$mailboxId/t/$threadId"
      preLoaderRoute: typeof AppMMailboxIdTThreadIdRouteImport
      parentRoute: typeof AppMMailboxIdRoute
    }
  }
}

interface AppFolderFolderIdRouteChildren {
  AppFolderFolderIdIndexRoute: typeof AppFolderFolderIdIndexRoute
  AppFolderFolderIdTThreadIdRoute: typeof AppFolderFolderIdTThreadIdRoute
}

const AppFolderFolderIdRouteChildren: AppFolderFolderIdRouteChildren = {
  AppFolderFolderIdIndexRoute: AppFolderFolderIdIndexRoute,
  AppFolderFolderIdTThreadIdRoute: AppFolderFolderIdTThreadIdRoute,
}

const AppFolderFolderIdRouteWithChildren =
  AppFolderFolderIdRoute._addFileChildren(AppFolderFolderIdRouteChildren)

interface AppMMailboxIdRouteChildren {
  AppMMailboxIdIndexRoute: typeof AppMMailboxIdIndexRoute
  AppMMailboxIdTThreadIdRoute: typeof AppMMailboxIdTThreadIdRoute
}

const AppMMailboxIdRouteChildren: AppMMailboxIdRouteChildren = {
  AppMMailboxIdIndexRoute: AppMMailboxIdIndexRoute,
  AppMMailboxIdTThreadIdRoute: AppMMailboxIdTThreadIdRoute,
}

const AppMMailboxIdRouteWithChildren = AppMMailboxIdRoute._addFileChildren(
  AppMMailboxIdRouteChildren,
)

interface AppRouteRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppFolderFolderIdRoute: typeof AppFolderFolderIdRouteWithChildren
  AppMMailboxIdRoute: typeof AppMMailboxIdRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppFolderFolderIdRoute: AppFolderFolderIdRouteWithChildren,
  AppMMailboxIdRoute: AppMMailboxIdRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ComposeRoute: ComposeRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
